export type DownloadedFile = {
  blob: Blob;
  fileName: string;
};

export function saveDownloadedFile(file: DownloadedFile, documentRef: Document = document) {
  const objectUrl = URL.createObjectURL(file.blob);
  const link = documentRef.createElement("a");
  link.href = objectUrl;
  link.download = file.fileName;
  documentRef.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(objectUrl);
}
